import React, { useContext, useEffect, useMemo } from "react";
import { Switch, message } from "antd";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import CommonTable from "../../common/CommonTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../../common/themeContext";
import Loader from "../Loder/loader";
import { getEnrollmentAgreementListHandler } from "../../redux/action/getEnrollmentAgreementListSlice";
import {
  updateEnrollmentAgreementStatusAction,
  updateEnrollmentAgreementStatusHandler,
} from "../../redux/action/updateEnrollmentAgreementStatusSlice";
import moment from "moment";

const EnrollmentAgreement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { brandId } = useContext(ThemeContext);
  const enrollmentAgreementListState = useSelector(
    (state) => state?.getEnrollmentAgreementList,
  );
  const updateStatusState = useSelector(
    (state) => state?.updateEnrollmentAgreementStatus,
  );

  const listPayload = useMemo(() => {
    return {
      refBrandId: brandId,
      search: "",
      limit: 10,
      offSet: 1,
      sortBy: "version",
      sortDirection: "desc",
    };
  }, [brandId]);

  useEffect(() => {
    dispatch(getEnrollmentAgreementListHandler(listPayload));
  }, [dispatch, listPayload]);

  useEffect(() => {
    if (!updateStatusState) return;
    if (updateStatusState?.message) {
      message.success(updateStatusState.message);
      dispatch(updateEnrollmentAgreementStatusAction.updateEnrollmentAgreementStatusInfoReset());
      dispatch(getEnrollmentAgreementListHandler(listPayload));
    }
    if (updateStatusState?.error) {
      message.error(updateStatusState.error);
      dispatch(updateEnrollmentAgreementStatusAction.updateEnrollmentAgreementStatusInfoReset());
    }
  }, [dispatch, listPayload, updateStatusState]);

  const rows = useMemo(() => {
    const items = Array.isArray(enrollmentAgreementListState?.data?.data)
      ? enrollmentAgreementListState.data.data
      : Array.isArray(enrollmentAgreementListState?.data)
        ? enrollmentAgreementListState.data
        : [];

    return items.map((item) => ({
      key: item?.id,
      id: item?.id,
      refBrandId: item?.refBrandId,
      documentName: item?.documentName ?? "",
      textContent: item?.textContent ?? null,
      documentContent: item?.documentContent ?? null,
      version: item?.version ?? "",
      lastUpdated: item?.modifiedAt ? moment(item.modifiedAt).format("YYYY-MM-DD") : "",
      status: String(item?.activeStatus || "").toUpperCase() === "ACTIVE",
      activeStatus: item?.activeStatus,
      createdAt: item?.createdAt,
      modifiedAt: item?.modifiedAt,
    }));
  }, [enrollmentAgreementListState?.data]);


  const columns = useMemo(
    () => [
      {
        title: "Document Name",
        dataIndex: "documentName",
        key: "documentName",
        render: (key) => {
          return (
            <div>{key || "-"}</div>
          );
        },
      },
      {
        title: "Last updated",
        dataIndex: "lastUpdated",
        key: "lastUpdated",
        render: (key) => {
          return (
            <div>{key || "-"}</div>
          );
        },
      },
      {
        title: "Version",
        dataIndex: "version",
        key: "version",
        render: (key) => {
          return (
            <div>{key || "-"}</div>
          );
        },
      },
    //   {
    //     title: "Status",
    //     dataIndex: "status",
    //     key: "status",
    //     render: (_, row) => (
    //       <Switch
    //         checked={row.status}
    //         loading={
    //           updateStatusState?.isLoading === true &&
    //           updateStatusState?.updatingId === row?.id
    //         }
    //         disabled={
    //           updateStatusState?.isLoading === true &&
    //           updateStatusState?.updatingId === row?.id
    //         }
    //         onChange={(checked) => {
    //           const nextStatus = checked ? "ACTIVE" : "INACTIVE";
    //           dispatch(
    //             updateEnrollmentAgreementStatusHandler({
    //               enrollmentAgreementId: row?.id,
    //               refBrandId: brandId,
    //               status: nextStatus,
    //             }),
    //           );
    //         }}
    //       />
    //     ),
    //   },
      {
        title: "Action",
        key: "action",
        render: (_, row) => (
          <button
            className="manage"
            type="button"
            onClick={() =>
              navigate("/ai-campaigns/enrollment-agreement-view", {
                state: { enrollmentAgreementId: row?.id },
              })
            }
          >
            Manage
          </button>
        ),
      },
    ],
    [brandId, dispatch, navigate, updateStatusState],
  );

  return (
    <div className="rightside">
      <div className="rightcontent">
        <p>
          <strong>Enrollment Agreement</strong>
        </p>
        <CustomBreadcrumb
          items={[
            { text: "Home" },
            { text: "AI Campaigns" },
            { text: "Enrollment Agreement", active: true },
          ]}
        />

        <div className="table-padding">
          <div className="headtitle">
            <p className="mb-0 heedprodct">Enrollment Agreement</p>
          </div>
          <hr className="m-0" />
          <div className="table-responsive">
            {(enrollmentAgreementListState?.isLoading === true ||
              updateStatusState?.isLoading === true) && (
                <Loader loaderTransform="loaderTransform" />
              )}
            <CommonTable
              handlePageChange={() => { }}
              pagination={{}}
              body={rows}
              columns={columns}
              isPagination={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentAgreement;